import { cap } from '../../../State'
import { translations } from '../../../translations'
import { Icon } from './Icons'

const language = cap.language.state || 'IT'
const t = translations[language]

export const ActionBar = ({
  errorCount,
  errorSectionLabel,
  primaryLabel,
  onPrimary,
  onSaveDraft,
  saveDraftVisible,
  onTakeCharge,
  takeChargeVisible,
  isSubmitting,
  readOnly,
  isRunning,
  inline,
  className = ''
}) => {
  if (readOnly && !takeChargeVisible) return null

  const disabled = errorCount > 0 || isSubmitting || isRunning
  const fieldLabel = errorCount === 1 ? t.gfCampo : t.gfCampi

  return (
    <div className={['gf-actionbar', inline && 'is-inline', className].filter(Boolean).join(' ')}>
      <div className="gf-actionbar__status">
        {isRunning ? (
          <>
            <span className="gf-badge gf-badge--warn">
              <span className="gf-actionbar__mini-spinner" aria-hidden="true" />
              {t.gfElaborazioneInCorso}
            </span>
            <span className="gf-actionbar__status-text">{t.gfAttendiCompletamentoTrasferta}</span>
          </>
        ) : errorCount > 0 ? (
          <>
            <span className="gf-badge gf-badge--err">
              <Icon name="alert" size={11} /> {errorCount} {fieldLabel} {t.gfCampiDaCompilare}
            </span>
            {errorSectionLabel && (
              <span className="gf-actionbar__status-text">
                {t.gfRisolviErroriIn} <b>{errorSectionLabel}</b> {t.gfPerCreareTrasferta}
              </span>
            )}
          </>
        ) : (
          <>
            <span className="gf-badge gf-badge--ok">
              <Icon name="check" size={11} /> {t.gfProntaDaCreare}
            </span>
            <span className="gf-actionbar__status-text">{t.gfTuttiCampiObbligatoriCompilati}</span>
          </>
        )}
      </div>
      <div className="gf-actionbar__buttons">
        {saveDraftVisible && (
          <button
            type="button"
            className="gf-btn"
            onClick={onSaveDraft}
            disabled={isSubmitting || isRunning}
          >
            <Icon name="save" size={14} />
            <span className="gf-lbl">{t.gfSalvaBozza}</span>
          </button>
        )}
        {!readOnly && (
          <button
            type="button"
            className="gf-btn gf-btn--primary"
            onClick={onPrimary}
            disabled={disabled}
          >
            <Icon name="check" size={14} />
            <span className="gf-lbl">{primaryLabel}</span>
          </button>
        )}
        {takeChargeVisible && (
          <button type="button" className="gf-btn" onClick={onTakeCharge}>
            <Icon name="handover" size={14} />
            <span className="gf-lbl">{t.prendiInCarico}</span>
          </button>
        )}
      </div>
    </div>
  )
}
